import { isEmpty as _isEmpty } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useTabletOrMobile from '../../../../../common/hooks/useTabletOrMobile';
import {
  getReportFormatLayoutState,
  setActiveSectionId,
  setFloatingTabsHeight,
  setFloatingTabsWidth,
  setFloatingTabsTop,
} from '../../../../../common/redux/reportFormat/reportFormatSlice';
import {
  findActiveSectionOnMobile,
  findActiveSectionOnDesktop,
} from './useActiveSectionsAlgos';
import CONSTANTS from './Constants';

const eventTypes = CONSTANTS.USER_EVENTS;

function useActiveSection(sectionElements, bottomPanelRef, rightPanelRef) {
  const dispatch = useDispatch();
  const isTabletOrMobile = useTabletOrMobile();
  const { activeSectionIndex } = useSelector(getReportFormatLayoutState);
  const [isPanelMounted, setIsPanelMounted] = useState(false);

  /*
   * ON RESIZE EVENT
   */
  const handleOnResizeEvent = useCallback(() => {
    if (rightPanelRef.current) {
      dispatch(
        setFloatingTabsWidth({
          width: rightPanelRef.current.offsetWidth,
        })
      );
    }
  }, [dispatch, rightPanelRef]);

  /*
   * ON SCROLL EVENT
   */
  const handleOnScrollEvent = useCallback(() => {
    if (!_isEmpty(sectionElements)) {
      let newSectionIndex;

      if (isTabletOrMobile) {
        newSectionIndex = findActiveSectionOnMobile(
          bottomPanelRef,
          sectionElements
        );
      } else {
        newSectionIndex = findActiveSectionOnDesktop(sectionElements);
      }

      if (
        activeSectionIndex !== newSectionIndex &&
        Boolean(sectionElements[newSectionIndex])
      ) {
        dispatch(setActiveSectionId({ index: newSectionIndex }));
      }
    }
  }, [
    activeSectionIndex,
    bottomPanelRef,
    dispatch,
    isTabletOrMobile,
    sectionElements,
  ]);

  /*
   * ON MOUNT
   */
  useEffect(() => {
    if (
      !isPanelMounted &&
      rightPanelRef.current &&
      !_isEmpty(sectionElements)
    ) {
      dispatch(
        setFloatingTabsTop({
          top: sectionElements[0].offsetTop,
        })
      );
      dispatch(
        setFloatingTabsHeight({
          height: sectionElements[0].offsetHeight,
        })
      );
      dispatch(
        setFloatingTabsWidth({
          width: rightPanelRef.current.offsetWidth,
        })
      );

      setIsPanelMounted(true);
    }
  }, [dispatch, isPanelMounted, rightPanelRef, sectionElements]);

  useEffect(() => {
    window.addEventListener(eventTypes.SCROLL, handleOnScrollEvent);
    return () => {
      window.removeEventListener(eventTypes.SCROLL, handleOnScrollEvent);
    };
  }, [handleOnScrollEvent]);

  useEffect(() => {
    window.addEventListener(eventTypes.RESIZE, handleOnResizeEvent);
    return () => {
      window.removeEventListener(eventTypes.RESIZE, handleOnResizeEvent);
    };
  }, [handleOnResizeEvent]);
}

export default useActiveSection;
